module.exports = __webpack_public_path__ + "static/media/login-background.1b2858a5.jpeg";